import { Modal, Col, Row, Button, Spinner } from "react-bootstrap";
import { useState, useEffect } from "react";
import CustomTextField from "./CustomTextField";
import { toast } from "react-toastify";
import { store } from "app/store";
import { API_URL } from "app/config";
import {
  useCreateFarmerMutation,
  useUploadFarmerMutation,
  useGetFarmerTaskDetailsQuery,
} from "features/onboarding/users/farmer/farmerApiSlice";
import { useGetmasterDropdownQuery } from "features/masterdata/MasterApiSlice";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import * as XLSX from "xlsx";
import { PinCodeComponent } from "./PinCodeComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FormGroup, Label, Input } from "reactstrap";
import StateDistrict from "features/onboarding/users/farmer/StateDistrict";
import { AssignFarmersBulk } from "features/onboarding/users/farmer/AssignFarmersBulk";
const ListViewActionItems = ({
  orgId,
  refetch,
  RoleAcessParams,
  currentUser,
  farmers,
  stateId,
  districtId,
  blockId,
  searchKey,
  farmerCategory,
  gender,
  showFields,SelectedFle,cropQueryString,selectedFpo,range,SortField,SortType,
}) => {
  const [showAddModal, setshowAddModal] = useState(false);
  const [taskVal, setTaskValue] = useState(false);

  const [createFarmer] = useCreateFarmerMutation();
  const [uploadFarmer] = useUploadFarmerMutation();
  const [state_id, setStateId] = useState("");
  const [district_id, setDistrictId] = useState("");
  const [block_id, setBlockId] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [blockList, setBlockList] = useState([]);

  const { data: TaskDetails } = useGetFarmerTaskDetailsQuery({
    skip: !taskVal,
  });
  const options = ["Loan", "Insurance", "Advisory", "Sell Produce"];

  const [disableButton, disableSubmitBtn] = useState(false);
  const [relationsDropdown, dropdownDataRelation] = useState([]);
  const [occupationDropdown, dropdownDataOccupation] = useState([]);
  const [categoryDropdown, dropdownDataCategory] = useState([
    "Marginal (Less than 2.5 acres)",
    "Small (2.5–5 acres)",
    "Semi Medium (5–10 acres)",
    "Medium (10–25 acres)",
    "Large (25 acres and above)",
  ]);
  const { data: dropdownData } = useGetmasterDropdownQuery();
  const [selectedFile, setSelectedFile] = useState();
  const [IsSelected, setIsSelected] = useState(false);

  const [showError, setError] = useState(false);
  const [taskDetails, setTaskDetails] = useState([]);
  const [activeTabs, setActiveTab] = useState("failed");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [dropdownDownlaodOpen, setDropdownDownloadOpen] = useState(false);
  const toggleDownloadDropdown = () =>
    setDropdownDownloadOpen(!dropdownDownlaodOpen);
  const [detail_type, setAddressBased] = useState("Pincode");
  const handleClose = () => {
    setshowAddModal(false);
    setError(false);
    setStateName("");
    setDistrictName("");
    setBlockName("");
    setStateId("");
    setDistrictId("");
    setBlockId("");
    setAddressBased("Pincode");
  };
  const [assignOption, setAssignOption] = useState(false);
  
  useEffect(() => {
    dropdownDataRelation(dropdownData?.data?.results[0]?.relations);
    dropdownDataOccupation(dropdownData?.data?.results[0]?.occupation);
    // dropdownDataCategory(dropdownData?.data?.results[0]?.farmer_category);
  }, [dropdownData]);
  useEffect(() => {
    if (TaskDetails) {
      setTaskDetails(TaskDetails?.data);
    }
  }, [TaskDetails]);
  const [Group, editGroup] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    DOB: "",
    // relative_name: "",
    // relative_type: "",
    farmer_category: "",
    primary_occupation: "Agriculture",
    secondary_occupation: "",
    gender: "",
    // caste: "",
    pincode: "",
    source: "Website",
    address: "",
  });
  const [showUploadBulk, UploadBulkModal] = useState(false);
  const handleCloseBulk = () => {
    UploadBulkModal(false);
  };
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };
  const AddModal = () => {
    setshowAddModal(true);
  };
  const onInputChange = (event) => {
    console.log(event.target.name);
    if (event.target.name == "DOB") {
      var date2 = event.target.value
        .split("-")
        .reverse()
        .join("-");
      editGroup({
        ...Group,
        [event.target.name]: date2,
      });
    } else {
      editGroup({
        ...Group,
        [event.target.name]: event.target.value,
      });
    }
  };

  const handleAddSubmit = (event) => {
    event.preventDefault();
    disableSubmitBtn(true);
    let payload;

    if (orgId && detail_type === "Pincode")
      payload = { ...Group, organization_id: orgId };
    else if (orgId && !detail_type === "Pincode")
      payload = {
        ...Group,
        state_name: stateName,
        state_code: state_id,
        district_name: districtName,
        district_code: district_id,
        block_code: block_id,
        block_name: blockName,
      };
    else if (detail_type === "Pincode") payload = { ...Group };
    else
      payload = {
        ...Group,
        state_name: stateName,
        state_code: state_id,
        district_name: districtName,
        district_code: district_id,
        block_code: block_id,
        block_name: blockName,
      };
    createFarmer(payload)
      .unwrap()
      .then((data) => {
        toast.success("Farmer Created");
        setshowAddModal(false);
        handleClose();

        disableSubmitBtn(false);
        refetch();
      })
      .catch((error) => {
        toast.error(
          error?.data?.message
            ? error?.data?.message
            : "Error while creating Farmer."
        );
        disableSubmitBtn(false);
        return;
      });
  };
  const handleSubmission = () => {
    const formData = new FormData();
    formData.append("users_csv", selectedFile);
    disableSubmitBtn(true);
    if (RoleAcessParams.includes("CBBO") || RoleAcessParams.includes("FPO")) {
      orgId = currentUser?.organization_id;
    }
    uploadFarmer({ formData, orgId })
      .unwrap()
      .then((data) => {
        toast.success("Farmer Uploaded");
        UploadBulkModal(false);
        disableSubmitBtn(false);

        // refetch()
        // window.location.reload()
      })
      .catch((error) => {
        toast.error("Error while Uploading Farmer");
        disableSubmitBtn(false);

        return;
      });
  };
  const handleTabClick = (taskId, tab) => {
    setActiveTab((prevTabs) => ({
      ...prevTabs,
      [taskId]: tab,
    }));
  };
  const tableHeaderStyle = {
    padding: "8px",
    textAlign: "left",
    backgroundColor: "#f1f1f1",
    borderBottom: "1px solid #ddd",
  };

  const tableCellStyle = {
    padding: "8px",
    borderBottom: "1px solid #ddd",
  };
  const convertToCSV = (data) => {
    const header = [
      "first_name",
      "last_name",
      "phone_number",
      "DOB",
      "gender",
      "pincode",
      "address",
      "error",
    ];
    const rows = data.map((user) => [
      user.first_name,
      user.last_name,
      user.phone_number,
      user.DOB,
      user.gender,
      user.pincode,
      user.address,
      user.error,
    ]);

    const csvContent = [
      header.join(","), // Add the header row
      ...rows.map((row) => row.join(",")), // Add data rows
    ]
      .map((row) => row.replace(/(\r\n|\n|\r)/gm, "")) // Clean up any new lines
      .join("\n");

    return csvContent;
  };
  const downloadCSV = (data) => {
    const csvContent = convertToCSV(data);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", "failed_users.csv");
    link.click();
  };

  const downloadExcel = async ({  pagination }) => {
    setLoading(true);
    const params = new URLSearchParams();
    if (orgId) params.append("organization_id", orgId);
    if (pagination?.page) params.append("page", pagination.page);
    params.append("per_page", "5000");
    if (stateId) params.append("state_code", stateId);
    if (districtId) params.append("district_code", districtId);
    if (blockId) params.append("block_code", blockId);
    if (searchKey) params.append("q", searchKey);
    if (farmerCategory) params.append("farmer_category", farmerCategory);
    if (gender) params.append("gender", gender);
     if (SelectedFle) params.append("created_by", SelectedFle);
        if (cropQueryString) params.append("crops", cropQueryString);
        if (SortField) params.append("sort_by", SortField);
        if (SortType) params.append("sort_order", SortType);
        if (selectedFpo) params.append("organization_id", selectedFpo);
          let queryString = params.toString();
        if (range) {queryString += `&date_range=${range}`;}
      
    const state = store.getState();
    const url = `${API_URL}/api/v1/onboarding/farmers?${queryString}`;
    try {
      const response = await fetch(url, {
        headers: {
          authorization: `Bearer ${state.auth.accessToken}`,
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }
      const farmers = await response.json();

      // const rows = farmers?.data?.results?.map(user => ({
      //   "Farmer Name": user.full_name || "",
      //   "Onboarding Date": user.created_at?.slice(0, 10) || "",
      //   "Phone Number": user.phone_number || "",
      //   "Gender": user.gender || "",
      //   "Age": user.age || "",
      //   "Category": user.farmer_category || "",
      //   "Landholding": user.total_land_holding || "",
      //   "Farm Score": user.total_acs || "",
      //   "State": user.state_name || "",
      //   "District": user.district_name || "",
      //   "Farmer ID": user.id || "",
      // }));
      const rows = farmers?.data?.results?.map((user) => {
        const createdAt = user.created_at
          ? new Date(user.created_at).toLocaleString("en-IN", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
          : "";

        return {
          "Farmer Name": user.full_name || "",
          "Onboarding Date": createdAt,
          "Phone Number": user.phone_number || "",
          Gender: user.gender || "",
          Age: user.age || "",
          Category: user.farmer_category || "",
          "Declared Landholding": user.total_land_holding || "",
          "Farm Score": user.total_acs || "",
          State: user.state_name || "",
          District: user.district_name || "",
          Block: user.block_name || "",
          Address: user.address || "",
          "Farmer ID": user.id || "",
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Farmers");
  
      XLSX.writeFile(workbook, "Farmers.csv");
    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setLoading(false);
    }
  };

  // const downloadVisible = async () => {
  //   const headers = [
  //     "Farmer Name", "Onboarding Date", "Phone Number",
  //     "Gender", "Age", "Category", "Landholding", "Farm Score","State","District","Farmer Id"
  //   ];

  //   const rows = farmers?.map(user => ({
  //     "Farmer Name": user.full_name || "",
  //     "Onboarding Date": user.created_at?.slice(0,10) || "",
  //     "Phone Number": user.phone_number || "",
  //     "Gender": user.gender || "",
  //     "Age": user.age || "",
  //     "Category": user.farmer_category || "",
  //     "Landholding": user.total_land_holding || "",
  //     "Farm Score": user.total_acs || "",
  //     "State": user.state_name || "",
  //     "District": user.district_name || "",
  //     "Farmer ID": user.id || "",

  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(rows);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Farmers");

  //   XLSX.writeFile(workbook, "Farmers.xlsx");

  // };

  const downloadGeojson = async () => {
    setLoading(true);

    // const state = store.getState();
    // const url = `${API_URL}/api/v1/onboarding/farmers?only_geojson=true`;
    const params = new URLSearchParams();
    if (orgId) params.append("organization_id", orgId);
    if (stateId) params.append("state_code", stateId);
    if (districtId) params.append("district_code", districtId);
    if (blockId) params.append("block_code", blockId);
    if (searchKey) params.append("q", searchKey);
    if (farmerCategory) params.append("farmer_category", farmerCategory);
    if (gender) params.append("gender", gender);
       if (SelectedFle) params.append("created_by", SelectedFle);
        if (cropQueryString) params.append("crops", cropQueryString);
        if (SortField) params.append("sort_by", SortField);
        if (SortType) params.append("sort_order", SortType);
        if (selectedFpo) params.append("organization_id", selectedFpo);
          let queryString = params.toString();
        if (range) {queryString += `&date_range=${range}`;}
    const state = store.getState();
    const url = `${API_URL}/api/v1/onboarding/farmers?${queryString}&only_geojson=true&per_page=5000`;

    try {
      const response = await fetch(url, {
        headers: {
          authorization: `Bearer ${state.auth.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }

      const farmers = await response.json();
      const geojsonData = farmers?.data;
      if (!geojsonData) {
        throw new Error("No GeoJSON data found in response");
      }

      const blob = new Blob([JSON.stringify(geojsonData, null, 2)], {
        type: "application/geo+json",
      });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "farmers.geojson";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error downloading GeoJSON:", error);
    } finally {
      setLoading(false);
    }
  };

  const ReloadApplication = () => {
    setTimeout(() => {
      refetch();
    }, 1500);
  };
  const [selectedServices, setSelectedServices] = useState([]);

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    let updatedServices = [...selectedServices];

    if (checked) {
      updatedServices.push(value);
    } else {
      updatedServices = updatedServices.filter((service) => service !== value);
    }

    setSelectedServices(updatedServices);

    // Convert array to a comma-separated string
    const formattedString = updatedServices.join(", ");

    // ✅ Ensure onInputChange follows event structure
    onInputChange({
      target: { name: "interested_services", value: formattedString },
    });
  };

  const onLocationChange = (event) => {
    if (event.ConditionName == "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName == "block") {
      setBlockId(event.value);
      setBlockName(event.label);
    }
  };

  return (
    <>
      <div class="coverOptions ">
        {showFields ? (
          <>
            <Button
              id="AddLeads"
              className="buttonOrangeDefaultColor"
              size="sm"
              onClick={(e) => AddModal(e)}
            >
              Add Farmer&nbsp;
              <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
            </Button>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle
                caret
                className="buttonOrangeDefaultColor2 p-2"
                size="sm"
                style={{ zIndex: "10000" }}
              >
                Upload Farmers &nbsp;
                <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    const state = store.getState();
                    fetch(`${API_URL}/api/v1/onboarding/farmers/bulk/csv`, {
                      headers: {
                        authorization: `Bearer ${state.auth.accessToken}`,
                      },
                    })
                      .then((res) => {
                        res.blob().then((blob) => {
                          const fileURL = window.URL.createObjectURL(blob);
                          let alink = document.createElement("a");
                          alink.href = fileURL;
                          alink.download = "farmers.csv";
                          alink.click();
                        });
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }}
                  className="dropdown-hover-item"
                >
                  Sample CSV
                </DropdownItem>
                <DropdownItem
                  onClick={(e) => UploadBulkModal(true)}
                  className="dropdown-hover-item"
                >
                  Upload CSV
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Dropdown
              isOpen={dropdownDownlaodOpen}
              toggle={toggleDownloadDropdown}
            >
              <DropdownToggle
                caret
                className="buttonGreenDefaultColor p-2"
                size="sm"
                style={{ zIndex: "10000" }}
              >
                Download &nbsp;
                <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>
                {loading ? <Spinner size="sm" /> : ""}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={downloadExcel}
                  className="dropdown-hover-item"
                >
                  CSV
                </DropdownItem>
                {/* <DropdownItem
                          onClick={downloadVisible}
                          className="dropdown-hover-item"
                        >
                           Filtered Farmers
                        </DropdownItem> */}
                {currentUser?.realm_access?.roles?.includes("HCL") ? (
                  ""
                ) : (
                  <DropdownItem
                    onClick={downloadGeojson}
                    className="dropdown-hover-item"
                  >
                    Geojson
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
            {(RoleAcessParams.includes("admin") ||
              RoleAcessParams.includes("developer")) && (
              <Button
                id="AddLeads"
                className="buttonGreenDefaultColor"
                style={{ backgroundColor: "#226f0a" }}
                onClick={() => {
                  setAssignOption(true);
                  localStorage.removeItem("selectedFarmerIds");
                  localStorage.removeItem("selectedFarmersDetails");
                }}
                size="sm"
              >
                Assign &nbsp;
                <i className="mdi mdi-account-arrow-right custom-btn-fs fs-6"></i>{" "}
                {/* {loading ? <Spinner size="sm" /> : ""} */}
              </Button>
            )}
          </>
        ) : (
          ""
        )}
        <Button
          className="bg-transparent text-black fs-6 reloadButton float-end"
          size="sm"
          onClick={ReloadApplication}
        >
          <FontAwesomeIcon icon={faRotateLeft} />
        </Button>
      </div>
      <Modal show={showAddModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            Add Farmer
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <form onSubmit={handleAddSubmit}>
            <Row className="text-gray">
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="first_name"
                  required
                  onChange={onInputChange}
                  className="text-gray"
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="last_name"
                  onChange={onInputChange}
                  className="text-gray"
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="phone_number"
                  required
                  maxLength="10"
                  onChange={onInputChange}
                  className="text-gray"
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="date"
                  name="DOB"
                  required
                  onChange={onInputChange}
                  className="text-gray"
                />
              </Col>
              {/* <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="relative_name"
                  required
                  onChange={onInputChange}
                  className="text-gray"
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="select"
                  name="relative_type"
                  required
                  onChange={onInputChange}
                  className="text-gray"
                  style={{ padding: "8px"}}
                >
                  <option value="">Select</option>
                  {relationsDropdown?.map((item, id) => {
                    return (
                      <option value={item} key={id}>
                        {item}
                      </option>
                    );
                  })}
                </CustomTextField>
              </Col> */}
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="select"
                  name="farmer_category"
                  required
                  onChange={onInputChange}
                  className="text-gray"
                  style={{ padding: "8px" }}
                >
                  <option value="">Select</option>
                  {categoryDropdown?.map((item, id) => {
                    return (
                      <option value={item} key={id}>
                        {item}
                      </option>
                    );
                  })}
                </CustomTextField>
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="text"
                  name="primary_occupation"
                  required
                  defaultValue="Agriculture"
                  disabled
                  className="text-gray"
                />
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="select"
                  name="secondary_occupation"
                  className="text-gray"
                  onChange={onInputChange}
                  style={{ padding: "8px" }}
                >
                  <option value="">Select</option>
                  {occupationDropdown?.map((item, id) => {
                    return (
                      <option value={item} key={id}>
                        {item}
                      </option>
                    );
                  })}
                </CustomTextField>
              </Col>
              <Col lg="3" className="mb-3">
                <CustomTextField
                  type="select"
                  name="gender"
                  className="text-gray"
                  required
                  style={{ padding: "8px" }}
                  onChange={onInputChange}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </CustomTextField>
              </Col>
              <Col lg="6" className="mb-3 mt-1">
                <Label className="mb-1">
                  Interested Services <span className="checkingcss"> *</span>
                </Label>
                <FormGroup className="d-flex flex-wrap mt-1">
                  {options.map((option) => (
                    <div key={option} className="me-3">
                      <Input
                        type="checkbox"
                        value={option}
                        checked={selectedServices.includes(option)}
                        onChange={handleCheckboxChange}
                      />
                      <Label className="ms-1">{option}</Label>
                    </div>
                  ))}
                </FormGroup>
              </Col>
              <Col lg="12" className="mt-1">
                <label>
                  <b>Add Details Based on</b>
                </label>
                <FormGroup className="mt-2">
                  <div className="d-flex flex-row">
                    <Label className="d-flex align-items-center">
                      <Input
                        type="radio"
                        name="Pincode"
                        value="Pincode"
                        checked={detail_type === "Pincode"}
                        onChange={(e) => setAddressBased(e.target.value)}
                      />
                      <span className="ms-2 mt-1">Pincode</span>
                    </Label>
                    <Label className="d-flex align-items-center mt-1 mx-5">
                      <Input
                        type="radio"
                        name="home"
                        value="StateLevel"
                        checked={detail_type === "StateLevel"}
                        onChange={(e) => setAddressBased(e.target.value)}
                      />
                      <span className="ms-2 mt-1">
                        Based on State, District, Block
                      </span>
                    </Label>
                  </div>
                </FormGroup>
              </Col>

              {detail_type === "Pincode" ? (
                <>
                  <Col lg="2" className="mb-3">
                    <CustomTextField
                      type="number"
                      name="pincode"
                      className="text-gray"
                      required
                      onChange={onInputChange}
                    />
                  </Col>
                  <PinCodeComponent pincode={Group?.pincode} />
                </>
              ) : (
                <StateDistrict
                  onLocationChange={onLocationChange}
                  state_id={state_id}
                  district_id={district_id}
                  block_id={block_id}
                  stateName={stateName}
                  districtName={districtName}
                  blockName={blockName}
                  setBlockList={setBlockList}
                  blockList={blockList}
                />
              )}

              <Col lg="4" className="mb-3">
                <CustomTextField
                  type="text"
                  name="address"
                  className="text-gray"
                  required
                  onChange={onInputChange}
                />
              </Col>
            </Row>

            <Button
              className="submit-btn"
              type="submit"
              disabled={disableButton ? true : false}
              style={{ float: "right" }}
            >
              Submit &nbsp;
              {disableButton ? <Spinner animation="border" size="sm" /> : ""}
            </Button>

            {showError ? (
              <div style={{ color: "red" }}>
                All The fields are mandatory **
              </div>
            ) : (
              ""
            )}
          </form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal show={showUploadBulk} onHide={handleCloseBulk} size="sm">
        <Modal.Header closeButton style={{ backgroundColor: "lightgrey" }}>
          <Modal.Title className="fw-bold">Bulk Upload</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          <div className="text-center mt-2 mx-2">
            <input
              type="file"
              name="file"
              accept=".csv"
              filename="users"
              onChange={changeHandler}
            />
            <div className="text-center d-flex justify-content-center">
              <Button className="submit-btn mt-3" onClick={handleSubmission}>
                Upload CSV &nbsp;{" "}
                {disableButton ? <Spinner animation="border" size="sm" /> : ""}
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
      <Modal show={taskVal} onHide={() => setTaskValue(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Task Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          <div style={{ padding: "20px", fontFamily: "Arial" }}>
            {taskDetails?.length ? (
              taskDetails.map((task) => {
                const activeTab = activeTabs[task.id] || "failed"; // Default to "failed"
                return (
                  <div
                    key={task.id}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      padding: "16px",
                      marginBottom: "16px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <div>
                      <p>
                        <strong>Status :</strong>{" "}
                        <span style={{ color: "green" }}>{task.status}</span>
                      </p>
                      <p>
                        <strong>Created At:</strong>{" "}
                        {new Date(task.created_at).toLocaleString()}
                      </p>
                    </div>

                    <div style={{ marginTop: "16px" }}>
                      <div style={{ display: "flex", gap: "16px" }}>
                        <button
                          onClick={() => handleTabClick(task.id, "failed")}
                          style={{
                            padding: "10px 20px",

                            color: activeTab === "failed" ? "orange" : "black",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Failed Users
                        </button>
                        <button
                          onClick={() => handleTabClick(task.id, "completed")}
                          style={{
                            padding: "10px 20px",

                            color:
                              activeTab === "completed" ? "orange" : "black",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Completed Users
                        </button>
                      </div>

                      {activeTab === "failed" ? (
                        task?.results?.failed_users?.length > 0 ? (
                          <div
                            style={{
                              marginTop: "16px",
                              maxHeight: "300px",
                              overflowY: "auto",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                            }}
                          >
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                              }}
                            >
                              <thead>
                                <tr>
                                  <th style={tableHeaderStyle}>Full Name</th>
                                  <th style={tableHeaderStyle}>Phone Number</th>
                                  <th style={tableHeaderStyle}>DOB</th>
                                  <th style={tableHeaderStyle}>Gender</th>
                                  <th style={tableHeaderStyle}>Pincode</th>
                                  <th style={tableHeaderStyle}>Error</th>
                                  <th style={tableHeaderStyle}>
                                    <button
                                      onClick={() =>
                                        downloadCSV(task?.results?.failed_users)
                                      }
                                      style={{
                                        backgroundColor: "#FFA500", // Orange color
                                        color: "#fff", // White text
                                        border: "none",
                                        borderRadius: "4px",
                                        padding: "5px 10px", // Small size
                                        cursor: "pointer",
                                        fontSize: "12px",
                                      }}
                                      onMouseOver={(e) =>
                                        (e.target.style.backgroundColor =
                                          "#FF8C00")
                                      } // Slightly darker orange on hover
                                      onMouseOut={(e) =>
                                        (e.target.style.backgroundColor =
                                          "#FFA500")
                                      }
                                    >
                                      Download
                                    </button>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {task?.results?.failed_users?.map(
                                  (user, index) => {
                                    //             const jsonString =

                                    // "{'DOB': [\"time data '-2003' does not match format '%d-%m-%Y'\"]}"
                                    // const obj = JSON.parse(jsonString);
                                    // console.log("obje",obj)

                                    return (
                                      <tr key={index}>
                                        <td style={tableCellStyle}>
                                          {user.full_name}
                                        </td>
                                        <td style={tableCellStyle}>
                                          {user.phone_number}
                                        </td>
                                        <td style={tableCellStyle}>
                                          {user.DOB}
                                        </td>
                                        <td style={tableCellStyle}>
                                          {user.gender}
                                        </td>
                                        <td style={tableCellStyle}>
                                          {user.pincode}
                                        </td>
                                        <td style={tableCellStyle}>
                                          {user.error}
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <p style={{ marginTop: "16px", color: "gray" }}>
                            No failed users.
                          </p>
                        )
                      ) : task?.results?.created_users?.length > 0 ? (
                        <div
                          style={{
                            marginTop: "16px",
                            maxHeight: "300px",
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                          }}
                        >
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                          >
                            <thead>
                              <tr>
                                <th style={tableHeaderStyle}>Full Name</th>
                                <th style={tableHeaderStyle}>Phone Number</th>
                                <th style={tableHeaderStyle}>DOB</th>
                                <th style={tableHeaderStyle}>Gender</th>
                                <th style={tableHeaderStyle}>Pincode</th>
                                <th style={tableHeaderStyle}>Address</th>
                              </tr>
                            </thead>
                            <tbody>
                              {task?.results?.created_users?.map(
                                (user, index) => (
                                  <tr key={index}>
                                    <td style={tableCellStyle}>
                                      {user.full_name}
                                    </td>
                                    <td style={tableCellStyle}>
                                      {user.phone_number}
                                    </td>
                                    <td style={tableCellStyle}>{user.DOB}</td>
                                    <td style={tableCellStyle}>
                                      {user.gender}
                                    </td>
                                    <td style={tableCellStyle}>
                                      {user.pincode}
                                    </td>
                                    <td style={tableCellStyle}>
                                      {user.address}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p style={{ marginTop: "16px", color: "gray" }}>
                          No completed users.
                        </p>
                      )}
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No task details available.</p>
            )}
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={assignOption}
        onHide={() => {
          setAssignOption(false);
          localStorage.removeItem("selectedFarmerIds");
          localStorage.removeItem("selectedFarmersDetails");
        }}
        size="xl"
      >
        <Modal.Header closeButton style={{ backgroundColor: "lightgrey" }}>
          <Modal.Title className="fw-bold">Assign Farmers</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2">
          <AssignFarmersBulk setAssignOption={setAssignOption} orgId={orgId} />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};
export default ListViewActionItems;
